export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const TERTIARY = 'tertiary';
export const QUATERNARY = 'quaternary';
export const PUNCHUP_SECONDARY = 'punchup_secondary';
export const PUNCHUP_TERTIARY = 'punchup_tertiary';
export const PUNCHUP_QUATERNARY = 'punchup_quaternary';
export const OUTLINED = 'outlined';
export const UNDERLINED = 'underlined';
